import { Component, Input, SimpleChanges } from '@angular/core';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from "@clr/angular";
import { RouterLink } from "@angular/router";
import { CurrencyPipe, DatePipe, DecimalPipe } from "@angular/common";
import { Invoices, StatusButtons } from "../../../../_shared/interfaces";
import * as XLSX from "xlsx";
import { AlertService, IAlertType, InvoicesStoreService } from "../../../../_shared/services";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";

@Component({
  selector: 'app-invoices-overview',
  standalone: true,
  imports: [
    ClrIconModule,
    ClrDatagridModule,
    RouterLink,
    DatePipe,
    DecimalPipe,
    CurrencyPipe
  ],
  templateUrl: './invoices-overview.component.html',
  styleUrl: './invoices-overview.component.sass'
})
export class InvoicesOverviewComponent {
  invoices: Invoices[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;

  @Input() status!: string;

  statusButtons: StatusButtons[] = [
    { state: 'all', display: 'Alle', label: 'alert-danger', icon: 'info-circle'},
    { state: 'open', display: 'Offen', label: 'alert-info', icon: 'info-circle'},
    { state: 'partially', display: 'Teilbezahlt', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'overdue', display: 'Fällig', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'paid', display: 'Bezahlt', label: 'alert-success', icon: 'check-circle'},
    { state: 'draft', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'cancelled', display: 'Storniert', label: 'alert-warning', icon: 'exclamation-triangle'}
  ];

  constructor(
    private invss: InvoicesStoreService,
    private alertDispatcher: AlertService,
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
  }

  ngOnInit() {
    this.loadList(this.status);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loading = true;
    this.loadList(this.status);
  }

  loadList(status: string) {
    this.invss.getInvoices(0, 0, '0', 0, 0, 'all')
      .subscribe({
        next: data => {
          this.invoices = data?.object ?? [];
          if (status !== 'all') this.invoices = this.invoices.filter(i => i.status === status);
          if (this.invoices.length === 0) {
            this.alertDispatcher.show({
              message: 'Keine Rechnungen gefunden.',
              clrAlertType: IAlertType.WARNING
            }, 2000);
          }
        },
        complete: () => {
          this.loading = false;
          this.descSort = ClrDatagridSortOrder.DESC;
        }
      })
  }


  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(offerstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === offerstatus)
  };

  getCellStatus(offerstatus: string) {
    const statusline = this.findButtonStatus(offerstatus, this.statusButtons);
    const btn = statusline >= 0 ? this.statusButtons[statusline] : { label: 'alert-info', display: offerstatus, icon: 'info-circle' };
    return {
      'statusLabel' : btn.label,
      'statusDisplay': btn.display,
      'statusIcon': btn.icon
    };
  }

  findButtonClass(offerstatus: string) {
    return "alert " + this.getCellStatus(offerstatus).statusLabel + " alert-sm";
  }

  exportToExcel(data: any): void {
    // Dokumentation: https://docs.sheetjs.com
    let invoices = data;
    invoices.map((obj: Invoices) => {
      let invoices = obj as Partial<Invoices>; // Type Assertion
      delete invoices['job_id'];
      delete invoices['delivery_id'];
      delete invoices['department'];
      delete invoices['comment_phm'];
      invoices['skonto'] = parseFloat((invoices['skonto'] ?? 0).toString());
      invoices['brutto'] = parseFloat((invoices['brutto'] ?? 0).toString());
      invoices['netto'] = Math.round(parseFloat((invoices['brutto'] ?? 0).toString())/1.19 * 100)/100;
      invoices['paid'] = parseFloat((invoices['paid'] ?? 0).toString());
    })
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(invoices);

    const book: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, worksheet, 'Invoices In Arbeit');

    XLSX.writeFile(book, 'Invoices-Übersicht.xlsx');
  }
}
